const STORAGE_KEY = "dople.trip-pre-itinerary-connect.v1";
const TTL_MS = 2 * 60 * 60 * 1000;

function readStorage(storage) {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.savedAt || Date.now() - parsed.savedAt > TTL_MS) {
      storage.removeItem(STORAGE_KEY);
      return null;
    }
    if (!parsed.tripId) return null;
    return parsed;
  } catch {
    return null;
  }
}

function writeStorage(storage, value) {
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Best-effort handoff only.
  }
}

function clearStorage(storage) {
  try {
    storage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function readPreItineraryConnect() {
  if (typeof window === "undefined") return null;
  // Prefer localStorage: Stripe Checkout is a full navigation away from the
  // app, and sessionStorage is easier to lose across tab/session edges.
  return readStorage(window.localStorage) || readStorage(window.sessionStorage);
}

export function writePreItineraryConnect({
  tripId,
  selectedOptionId = "",
  themeTitle = "",
  thesis = "",
  purchaseType = "",
  fromConnect = false,
} = {}) {
  if (typeof window === "undefined" || !tripId) return;
  const value = {
    savedAt: Date.now(),
    tripId: String(tripId),
    selectedOptionId: String(selectedOptionId || ""),
    themeTitle: String(themeTitle || ""),
    thesis: String(thesis || ""),
    purchaseType: String(purchaseType || ""),
    fromConnect: Boolean(fromConnect),
  };
  writeStorage(window.localStorage, value);
  writeStorage(window.sessionStorage, value);
}

export function clearPreItineraryConnect() {
  if (typeof window === "undefined") return;
  clearStorage(window.localStorage);
  clearStorage(window.sessionStorage);
}

export function purchaseTypeNeedsPreItineraryConnect(purchaseType) {
  return (
    purchaseType === "trip_standard" ||
    purchaseType === "trip_member" ||
    purchaseType === "membership_plus_trip"
  );
}

// Option id from the Connect handoff when it belongs to this trip and is still
// one of its options. Lets a reload during preparation resume the build.
export function pendingConnectOptionId(pending, tripId, options = []) {
  if (!pending?.tripId || String(pending.tripId) !== String(tripId || "")) return "";
  const optionId = String(pending.selectedOptionId || "");
  if (!optionId) return "";
  return (options || []).some((option) => String(option?.id) === optionId) ? optionId : "";
}
